module.exports = __webpack_public_path__ + "assets/icon-certified-developer.a904d3be.svg";